module.exports = __webpack_public_path__ + "static/media/lang.b6a8fecf.png";